import {useMembership} from "../../hooks/MembershipProvider/MembershipProvider";
import React from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import "./Payment.css";

const Fail = () => {
  const {isAuthenticated,user,isEmbed} = useMembership();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  console.log(searchParams);
  
  return (
    <>
      <div className={`content_wrap fail flex justify-center items-center  ${isEmbed() ? `app`:``}`}>
        <div className={`section_wrap sec_wrap_1 !w-[100%]`}>
          <div className={`sec text-center`}>
            <img src={`../contents/img_error.png`} alt={``} className={`img`}/>
            <h3 className={`h3 mb-3`}>결제에 실패했어요</h3>
            <button onClick={()=>navigate(-3)} className={`btn btn-primary`}>
              돌아가기
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
export default Fail;